import React from 'react';
import { FormattedDate } from 'react-intl';

import classnames from 'classnames';

import { ImageSize } from '@nxte-nl/image-hooks';

import {
  LayoutExtensionContainer,
} from '../../containers/LayoutExtensionContainer/LayoutExtensionContainer';
import { UrlType } from '../../types/apiEnums';
import {
  ImagePresentational,
  LinkPresentational,
} from '../../types/common';
import { DangerouslySetInnerHtml } from '../DangerouslySetInnerHtml/DangerouslySetInnerHtml';
import { ImageWithSize } from '../ImageWithSize/ImageWithSize';
import { Link, LinkType } from '../Link/Link';
import { Typography } from '../Typography/Typography';
import { Chevron as ChevronIcon } from '../icons';
import { ChevronColor } from '../icons/Chevron/Chevron';
import styles from './ContentPageCard.module.css';

export type ContentPageCardPresentational = {
  body: string | null;
  image: ImagePresentational | null;
  link: LinkPresentational;
  title: string;
};

export type Props = ContentPageCardPresentational & {
  isBodyADate?: boolean;
  onClick: React.MouseEventHandler;
};

export const ContentPageCard = React.memo((props: Props) => {
  const {
    title,
    body,
    image,
    link,
    isBodyADate = false,
    onClick,
  } = props;

  return (
    <Link
      type={link.url.type === UrlType.ABSOLUTE ? LinkType.ExternalHref : LinkType.Href}
      to={link.url.href}
      className={styles.contentPageCard}
      onClick={onClick}
    >
      <>
        <div className={styles.imageContainer}>
          <ImageWithSize
            image={image}
            size={ImageSize.L}
          />
        </div>

        <Typography component='p' variant='h4' size={'m'} className={styles.title}>
          {title}
        </Typography>

        <Typography component='div' variant='body1' className={styles.text}>
          {isBodyADate
            ? body && <FormattedDate
              value={body}
              year='numeric'
              month='long'
              day='2-digit'
            />
            : body
          && <DangerouslySetInnerHtml
            dangerousHtml={body}
          />
          }
        </Typography>

        <div className={styles.navButton}>
          <LayoutExtensionContainer>
            {({ isDesktop }) => (
              <ChevronIcon
                className={classnames(styles.navButtonIcon, styles.navButtonChevronIcon)}
                fill={ChevronColor.accentWhite}
                variant='right'
                width={isDesktop ? 22 : 15}
                height={isDesktop ? 22 : 15}
              />
            )}
          </LayoutExtensionContainer>

        </div>
      </>
    </Link>
  );
});

ContentPageCard.displayName = 'ContentPageCard';
